import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { ReserveCommentPointsPropertiesType } from "@website/widget/reserve-comment/reserve-comment-points/reserve-points.types";
export const ReserveCommentPoints = t0 => {
  const $ = _c(7);
  const {
    properties
  } = t0;
  const {
    message,
    type
  } = properties;
  let t1;
  if ($[0] !== type) {
    t1 = <div className="flex w-[115px] flex-row items-center gap-1 md:w-[20px] md:justify-center">{type === "strengths" ? <><MaterialIcon className="text-ventures-snapp md:text-headline-6" name="thumb_up" variant="outlined" /><span className="text-ventures-snapp md:text-headline-6 text-overline md:hidden">نقاط قوت</span></> : <><MaterialIcon className="text-error md:text-headline-6" name="thumb_down" variant="outlined" /><span className="text-error md:text-headline-6 text-overline md:hidden">نقاط ضعف</span></>}</div>;
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message) {
    t2 = <div>{message}</div>;
    $[2] = message;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="text-caption md:text-body-2 flex flex-col items-start gap-1 md:flex-row md:items-center md:gap-6 md:pr-4 md:ltr:pl-4">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};